import create from 'zustand';

const useStore = create((set) => ({
	query: undefined,
	setQuery: (value) => set({ query: value }),
}));

export default useStore;
